<template>
  <!-- ADD STAFF -->
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="addEditSubscriptionPricingModal"
      persistent
      max-width="600px"
    >
      <v-card>
        <form
          action=""
          @submit.prevent="submitForm()"
        >
          <v-card-title>
            <v-flex
              xs11
              sm11
              md11
            ><span class="headline">{{ addEditData.pricing_id ? 'Edit' : 'Add' }} Subscription Pricing</span></v-flex>
            <v-flex
              xs1
              sm1
              md1
            >
              <v-btn
                flat
                @click="closeAddEditSubscriptionPricingModal(), $validator.reset()"
                class="close"
              ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-alert
              type="success"
              :value="checkAlert"
            >
              Staff added successfully
            </v-alert>
            <v-layout wrap>
              <v-flex
                xs12
                md12
                class="px-2"
              >
                <v-select
                  :items="warehouses"
                  item-value="value"
                  v-model="addEditData.warehouse_id_fk"
                  :error-messages="errors.collect('Warehouse')"
                  data-vv-name="Warehouse"
                  label="Warehouse*"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                  :disabled="!!addEditData.pricing_id"
                >
                </v-select>
              </v-flex>
              <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md12
                >
                  <v-select
                    autocomplete
                    :items="orderTypes"
                    item-value="value"
                    v-model="addEditData.order_type_id_fk"
                    :error-messages="errors.collect('order_type_id_fk')"
                    data-vv-name="order_type_id_fk"
                    label="Order Type*"
                    v-validate="'required'"
                    multiple
                    chips
                    deletable-chips
                    :disabled="!!addEditData.pricing_id"
                  >
                  </v-select>
              </v-flex>
              <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md12
                >
                  <v-select
                    autocomplete
                    :items="subscriptions"
                    item-value="value"
                    v-model="addEditData.subscription_id"
                    :error-messages="errors.collect('subscription_id')"
                    data-vv-name="subscription_id"
                    label="Subscription*"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
              </v-flex>
              <v-flex class="px-2"
                  xs12
                  sm12
                  md12>
                <v-text-field
                  v-model="addEditData.order_shipzone_fee"
                  :error-messages="errors.collect('order_shipzone_fee')"
                  data-vv-name="order_shipzone_fee"
                  label="Order Shipzone Fee*"
                  v-validate="'required|decimal'"
                  single-line
                ></v-text-field>
              </v-flex>
              <v-flex class="px-2"
                  xs12
                  sm6
                  md6>
                <v-text-field
                  v-model="addEditData.shiponly_handling_fee_air"
                  :error-messages="errors.collect('shiponly_handling_fee_air')"
                  data-vv-name="shiponly_handling_fee_air"
                  label="Shiponly Handling Fee (Air)*"
                  v-validate="'required|decimal'"
                  single-line
                ></v-text-field>
              </v-flex>
              <v-flex class="px-2"
                  xs12
                  sm6
                  md6>
                <v-text-field
                  v-model="addEditData.shiponly_handling_fee_sea"
                  :error-messages="errors.collect('shiponly_handling_fee_sea')"
                  data-vv-name="shiponly_handling_fee_sea"
                  label="Shiponly Handling Fee (Sea)*"
                  v-validate="'required|decimal'"
                  single-line
                ></v-text-field>
              </v-flex>
              <v-flex class="px-2"
                  xs12
                  sm6
                  md6>
                <v-text-field
                  v-model="addEditData.item_price_air"
                  :error-messages="errors.collect('item_price_air')"
                  data-vv-name="item_price_air"
                  label="Shipping Price (Air)*"
                  v-validate="'required|decimal'"
                  single-line
                ></v-text-field>
              </v-flex>
              <v-flex class="px-2"
                  xs12
                  sm6
                  md6>
                <v-text-field
                  v-model="addEditData.item_price_sea"
                  :error-messages="errors.collect('item_price_sea')"
                  data-vv-name="item_price_sea"
                  label="Shipping Price (Sea)*"
                  v-validate="'required|decimal'"
                  single-line
                ></v-text-field>
              </v-flex>
              <v-flex class="px-2"
                  xs6
                  sm6
                  md6>
                <v-text-field
                  v-model="addEditData.item_price_land"
                  :error-messages="errors.collect('item_price_land')"
                  data-vv-name="item_price_land"
                  label="Shipping Price (Land)*"
                  v-validate="'required|decimal'"
                  single-line
                ></v-text-field>
              </v-flex>
              <v-flex class="px-2"
                  xs6
                  sm6
                  md6>
                <v-text-field
                  v-model="addEditData.local_delivery"
                  :error-messages="errors.collect('local_delivery')"
                  data-vv-name="local_delivery"
                  label="Local Delivery*"
                  v-validate="'required|decimal'"
                  single-line
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeAddEditSubscriptionPricingModal(), $validator.reset()"
              outline
              color="normal"
            >Cancel</v-btn>
            <v-btn
              type="submit"
              style="height:auto; margin-right: 3%"
              outline
              color="success"
            >Save</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
  <!-- /ADD Edit User Subscription -->
</template>

<script>
import axios from 'axios'

export default {
  props: [
    'warehouses',
    'orderTypes',
    'addEditData',
    'addEditSubscriptionPricingModal',
    'submitAddEditUserSubscription',
    'checkAlert',
    'subscriptions',
    'closeAddEditSubscriptionPricingModal',
    'validationError'
  ],

  data() {
    return {
    }
  },

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.submitAddEditUserSubscription()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog-dialog--active-dialog--persistent {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/subscription_pricing/addEditSubscriptionPricing.vue